const { gql } = require('graphql-tag/lib/graphql-tag.umd');

Object.defineProperty(exports, '__esModule', {
  value: true,
});

const fragments = (exports.fragments = {
  SaleCarouselSale: gql`
    fragment SaleCarouselSale on Sale {
      endDate
      id
      minBid
      price
      saleType
      product {
        name
        __typename
      }
      __typename
    }
  `,
  SalePageBid: gql`
    fragment SalePageBid on Bid {
      amount
      createdDate
      id
      index
      isLeadingBid
      maxAmount
      status
      user {
        id
        isSelf
        __typename
        displayName {
          value
          __typename
        }
      }
      __typename
    }
  `,
  SalePageSale: gql`
    fragment SalePageSale on Sale {
      bidCount
      bidderCount
      endDate
      endDateExtendedMs
      id
      updatedDate
      minBid
      price
      renewPrice
      saleType
      selfHasActiveInvoice
      selfIsLeadingBidder
      status
      product {
        ahrefsDomainRating
        alexaRanking
        backlinksCount
        estibotValue
        extensionsTaken
        keywordSearchCount
        keywordSearchQuery
        monthlyVisitors
        name
        pageRank
        registeredDate
        soldPrice
        soldYear
        umbrellaRanking
        mostRecentSale {
          id
          __typename
        }
        __typename
      }
      __typename
    }
  `,
  SaleTableSale: gql`
    fragment SaleTableSale on Sale {
      bidCount
      endDate
      id
      minBid
      price
      saleType
      status
      product {
        name
        __typename
      }
      __typename
    }
  `,
  SaleTablePageSales: gql`
    fragment SalesTablePageSales on PaginatedSales {
      items {
        ...SaleTableSale
        __typename
      }
      page
      pageCount
      pageSize
      total
      __typename
    }
  `,
});

exports.default = {
  BuyNowTable: gql`
    query BuyNowTable(
      $filter: SaleFilter
      $page: Int
      $pageSize: Int
      $sort: [SaleSort]
    ) {
      binSales(filter: $filter, page: $page, pageSize: $pageSize, sort: $sort) {
        ...SalesTablePageSales
        __typename
      }
    }
    ${fragments.SaleTablePageSales}
    ${fragments.SaleTableSale}
  `,
  CollectionTable: gql`
    query CollectionTable(
      $collectionId: String!
      $filter: SaleFilter
      $page: Int
      $pageSize: Int
      $sort: [SaleSort]
    ) {
      collection(id: $collectionId, idType: slug) {
        heading
        id
        subheading
        saleType
        sales(filter: $filter, page: $page, pageSize: $pageSize, sort: $sort) {
          ...SalesTablePageSales
          __typename
        }
        __typename
      }
    }
    ${fragments.SaleTablePageSales}
    ${fragments.SaleTableSale}
  `,
  CancelSubscription: gql`
    mutation CancelSubscription {
      cancelSubscription {
        success
        __typename
      }
    }
  `,
  CreateAPIToken: gql`
    mutation CreateAPIToken {
      createAPIToken {
        user {
          id
          token
          __typename
        }
        __typename
      }
    }
  `,
  CreateBid: gql`
    mutation CreateBid($amount: Float!, $sale: String!) {
      createBid(input: { maxAmount: $amount, sale: $sale }) {
        bid {
          id
          isLeadingBid
          isSnipe
          maxAmount
          __typename
        }
        sale {
          id
          endDate
          minBid
          product {
            id
            name
            __typename
          }
          __typename
        }
        success
        __typename
      }
    }
  `,
  DeleteAPIToken: gql`
    mutation DeleteAPIToken {
      deleteAPIToken {
        user {
          id
          token
          __typename
        }
        __typename
      }
    }
  `,
  IncrementSaleViewCount: gql`
    mutation IncrementSaleViewCount($id: String!) {
      incrementSaleViewCount(input: { id: $id }) {
        success
        __typename
      }
    }
  `,
  LoginWithAuthCode: gql`
    mutation LoginWithAuthCode($code: String!, $redirectURI: String!) {
      loginWithNAMPAuthCode(input: { code: $code, redirectURI: $redirectURI }) {
        success
        __typename
      }
    }
  `,
  Logout: gql`
    mutation Logout {
      logout {
        success
        __typename
      }
    }
  `,
  MarketHome: gql`
    query MarketHome($pageSize: Int!) {
      collections {
        heading
        id
        slug
        subheading
        theme
        sales(page: 1, pageSize: $pageSize) {
          total
          items {
            ...SaleCarouselSale
            __typename
          }
          __typename
        }
        __typename
      }
    }
    ${fragments.SaleCarouselSale}
  `,
  MarketStats: gql`
    query MarketStats {
      marketStats {
        auctionPriceP95
        buyPriceP95
        __typename
      }
    }
  `,
  DomainSearchAuctions: gql`
    query DomainSearchAuctions {
      sales(filter: { saleType: auction }, pageSize: 5) {
        items {
          bidCount
          endDate
          price
          product {
            name
          }
        }
      }
    }
  `,
  SalePage: gql`
    query SalePage($bidLimit: Int, $id: String!, $idType: SALE_ID_TYPE!) {
      sale(id: $id, idType: $idType) {
        ...SalePageSale
        bids(limit: $bidLimit) {
          ...SalePageBid
          __typename
        }
        __typename
      }
    }
    ${fragments.SalePageBid}
    ${fragments.SalePageSale}
  `,
  SalePageBIN: gql`
    query SalePageBIN($domain: String!) {
      binSale(domain: $domain) {
        ...SalePageSale
        __typename
      }
    }
    ${fragments.SalePageSale}
  `,
  SalePageCollection: gql`
    query SalePageCollection($pageSize: Int!) {
      collection: sales(
        filter: { saleType: auction, trending: true }
        page: 1
        pageSize: $pageSize
      ) {
        total
        items {
          ...SaleCarouselSale
          __typename
        }
        __typename
      }
    }
    ${fragments.SaleCarouselSale}
  `,
  SaleTable: gql`
    query SaleTable(
      $filter: SaleFilter
      $page: Int
      $pageSize: Int
      $sort: [SaleSort]
    ) {
      sales(filter: $filter, page: $page, pageSize: $pageSize, sort: $sort) {
        ...SalesTablePageSales
        __typename
      }
    }
    ${fragments.SaleTablePageSales}
    ${fragments.SaleTableSale}
  `,
  SaleTablePageRealtimeSync: gql`
    query SaleTablePageRealtimeSync($ids: [String]!) {
      salesById(ids: $ids) {
        id
        bidCount
        endDate
        price
        __typename
      }
    }
  `,
  Subscribe: gql`
    mutation Subscribe($returnTo: String) {
      subscribe(input: { returnTo: $returnTo }) {
        redirectURI
        success
        __typename
      }
    }
  `,
  SubscribeConfirm: gql`
    mutation SubscribeConfirm($token: String!) {
      subscribeConfirm(input: { token: $token }) {
        success
        __typename
      }
    }
  `,
  UpdateDisplayName: gql`
    mutation UpdateDisplayName($displayName: String!) {
      updateDisplayName(input: { displayName: $displayName }) {
        user {
          id
          displayName {
            updatedDate
            value
            __typename
          }
          __typename
        }
        __typename
      }
    }
  `,
  UpdateWebhook: gql`
    mutation UpdateWebhook($url: String) {
      updateWebhookURL(input: { url: $url }) {
        user {
          id
          webhookURL
          __typename
        }
        __typename
      }
    }
  `,
  UserBidding: gql`
    query UserBidding($page: Int, $pageSize: Int, $sort: [SaleSort]) {
      self {
        id
        bidding(page: $page, pageSize: $pageSize, sort: $sort) {
          total
          items {
            ...SaleTableSale
            __typename
          }
          __typename
        }
        __typename
      }
    }
    ${fragments.SaleTableSale}
  `,
  UserContext: gql`
    query UserContext {
      self {
        id
        status
        bidding {
          items {
            id
            selfIsLeadingBidder
            status
            bids(limit: 2) {
              id
              status
              user {
                id
                isSelf
                __typename
              }
              __typename
            }
            product {
              name
              __typename
            }
            __typename
          }
          __typename
        }
        watchedProducts {
          name
          __typename
        }
        __typename
      }
    }
  `,
  UserSettings: gql`
    query UserSettings {
      self {
        id
        isBetaTester
        token
        username
        webhookURL
        displayName {
          value
          updatedDate
          __typename
        }
        subscription {
          expiredDate
          plan
          price
          __typename
        }
        __typename
      }
    }
  `,
  UserWatching: gql`
    query UserWatching(
      $filter: SaleFilter
      $page: Int
      $pageSize: Int
      $sort: [SaleSort]
    ) {
      self {
        id
        watching(
          filter: $filter
          page: $page
          pageSize: $pageSize
          sort: $sort
        ) {
          pageCount
          total
          items {
            ...SaleTableSale
            saleType
            __typename
          }
          __typename
        }
        __typename
      }
    }
    ${fragments.SaleTableSale}
  `,
  UserInvoices: gql`
    query UserInvoices(
      $filter: InvoiceFilter
      $page: Int
      $pageSize: Int
      $sort: [InvoiceSort]
    ) {
      self {
        id
        invoices(
          filter: $filter
          page: $page
          pageSize: $pageSize
          sort: $sort
        ) {
          pageCount
          total
          items {
            expiredDate
            isPaid
            sale {
              ...SaleTableSale
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
    }
    ${fragments.SaleTableSale}
  `,
  UserInvoicesMeta: gql`
    query UserInvoicesMeta {
      self {
        id
        expired: invoices(filter: { invoiceType: expired }) {
          total
          __typename
        }
        paid: invoices(filter: { invoiceType: paid }) {
          total
          __typename
        }
        unpaid: invoices(filter: { invoiceType: unpaid }) {
          total
          __typename
        }
        __typename
      }
    }
  `,
  Watch: gql`
    mutation Watch($watch: [String], $unwatch: [String]) {
      watch(input: { add: $watch, remove: $unwatch }) {
        success
        products {
          name
          __typename
        }
        __typename
      }
    }
  `,
};
